import { style } from '@vanilla-extract/css';

import columnStyles from '../columnElement/Column.css';
import rootStyles from '../rootElement/Root.css';

const { rootElement } = rootStyles;

const paragraphElement = style({
  position: 'var(--position, relative)',
  top: 'var(--position-top)',
  right: 'var(--position-right)',
  bottom: 'var(--position-bottom)',
  transform: 'var(--position-transform)',
  left: 'var(--position-left)',
  zIndex: 'var(--z-index)',
  color: 'inherit',
  margin: 'var(--margin)',
  padding: 'var(--padding)',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  lineHeight: 'var(--line-height)',
  textAlign: 'var(--text-align)',
  backgroundColor: 'var(--background-color)',
  borderRadius: 'var(--border-radius)',
  borderWidth: 'var(--border-width)',
  borderColor: 'var(--border-color)',
  borderStyle: 'var(--border-style)',
  letterSpacing: 'var(--letter-spacing)',

  '@media': {
    'only screen and (--mobile)': {
      lineHeight: 'var(--mobile-line-height)',
      textAlign: 'var(--mobile-text-align)',
      padding: 'var(--mobile-padding, var(--padding))',
    },
  },

  selectors: {
    '&:empty::before': {
      content: '\u00a0',
    },
    [`.ProseMirror > .react-renderer > &, ${rootElement} > &`]: {
      padding: 'var(--padding-root)',
    },
    [`${columnStyles.columnItemElement} > div > &`]: {
      width: '100%',
    },
  },
});

export default {
  paragraphElement,
};
